document.addEventListener('DOMContentLoaded', () => {
    initUserDevice();
});

function initUserDevice() {
    const isUserDevice = document.querySelector('#updateDevicesData');
    if (!isUserDevice) {
        return;
    }

    const userDevice = new UserDevice();
    userDevice.init();
}

class UserDevice {
    constructor() {
        this.isProcessing = false;
    }

    init() {
        setInterval(() => {
            if (this.isProcessing) {
                return;
            }

            this.isProcessing = true;

            const rows = document.querySelectorAll('table tr[data-id]');
            let ids = [];

            const rowPointMap = {};

            rows.forEach(row => {
                const id = row.getAttribute('data-id');
                ids.push(id);

                const pointContainer = row.closest('[data-point-id]');
                if (pointContainer) {
                    const pointId = pointContainer.getAttribute('data-point-id');
                    rowPointMap[id] = pointId;
                }
            });

            if (ids.length > 0) {
                const url = document.querySelector('#updateDevicesData').value;
                if (!url) {
                    return;
                }

                this.postData(url, { ids: ids })
                    .then(payload => {
                        if (!payload || !payload.data) {
                            console.error('Chybějící nebo neplatný payload');
                            return;
                        }

                        const pointConsumptions = {};

                        Object.keys(payload.data).forEach((key) => {
                            const row = document.querySelector(`table tr[data-id="${key}"]`);
                            if (!row) {
                                console.warn(`Řádek s ID ${key} nenalezen`);
                                return;
                            }

                            const pointId = rowPointMap[key];
                            if (!pointId) {
                                return;
                            }

                            if (!pointConsumptions[pointId]) {
                                pointConsumptions[pointId] = 0;
                            }

                            Object.entries(payload.data[key]).forEach(([cellKey, value]) => {
                                const cell = row.querySelector('td.' + cellKey);
                                if (cellKey == 'col-mode') {
                                    if (value === 'disabled') {
                                        const buttons = cell.querySelectorAll('.btn');
                                        buttons.forEach(btn => {
                                            btn.classList.add('disabled');
                                            btn.setAttribute('aria-disabled', 'true');
                                        });
                                    } else {
                                        const buttons = cell.querySelectorAll('.btn');
                                        buttons.forEach(btn => {
                                            btn.classList.remove('disabled');
                                            btn.setAttribute('aria-disabled', 'false');
                                        });
                                    }
                                } else if (cell && value) {
                                    cell.innerHTML = value;
                                } else if (cellKey == 'col-actualConsumptionPlain') {
                                    // Přidat spotřebu ke správné lokalitě
                                    pointConsumptions[pointId] += value ? parseFloat(value) : 0;
                                }
                            });
                        });

                        Object.keys(pointConsumptions).forEach(pointId => {
                            const container = document.querySelector(`[data-point-id="${pointId}"]`);
                            if (container) {
                                const summaryElement = container.querySelector('.datagrid-row-columns-summary .col-actualConsumption');
                                if (summaryElement && summaryElement.textContent.indexOf('měření viz níže') === -1) {
                                    summaryElement.textContent = pointConsumptions[pointId] + ' W';

                                    // const kw = pointConsumptions[pointId] === null ? null : (pointConsumptions[pointId] / 1000);
                                    // const kwStr = kw === null ? 'N/A' : kw.toFixed(2) + ' kW';
                                    // summaryElement.textContent = kwStr;
                                }
                            }
                        });

                        // Aktualizace balance sekce, pokud jsou data k dispozici
                        if (payload.balanceData) {
                            this.updateBalanceSection(payload.balanceData);
                        }
                    })
                    .catch((error) => {
                        console.error('Chyba při odesílání dat:', error);
                    })
                    .finally(() => {
                        this.isProcessing = false;
                    });
            } else {
                this.isProcessing = false;
            }
        }, 1000);
    }

    updateBalanceSection(balanceData) {
        // Aktualizace objektů (lightnings)
        if (balanceData.lightnings) {
            balanceData.lightnings.forEach((lightning, index) => {
                const counter = index + 1;
                const objectWrapper = document.querySelector(`.balance-grid .balance-col-1 .icon-wrapper:nth-child(${counter})`);

                if (!objectWrapper) {
                    return;
                }

                // Detekce struktury: balance (triple) nebo lighting (double)
                const isBalanceMode = objectWrapper.classList.contains('icon-wrapper-balance');
                const isLightingMode = !isBalanceMode;

                // === BALANCE MODE (triple structure) ===
                if (isBalanceMode) {
                    // Aktualizace ikony baterie
                    const batteryImg = objectWrapper.querySelector('.img-wrapper-left .img-wrapper-cell:nth-child(2) img');
                    if (batteryImg) {
                        if (lightning.availableCapacityIcon === null || lightning.measuredFlowKw === null) {
                            batteryImg.src = '/dist/imgs/battery-small.jpg';
                        } else {
                            batteryImg.src = `/dist/imgs/battery-small-${lightning.availableCapacityIcon}.png?v2`;
                        }
                    }

                    // Aktualizace hodnot FVE / Baterie / Dům nad ikonami
                    const fveCell = objectWrapper.querySelector('.img-wrapper-left .img-wrapper-cell:nth-child(1)');
                    if (fveCell) {
                        const fveSpan = fveCell.querySelector('span');
                        const vKw = lightning.measuredFlowFveKw; // float
                        if (fveSpan) {
                            if (vKw === null || vKw === undefined) {
                                fveSpan.innerHTML = 'N/A';
                            } else {
                                const formatted = vKw.toFixed(2);
                                if (vKw === 0) {
                                    fveSpan.innerHTML = `<strong>${formatted} kW</strong>`;
                                } else {
                                    const cls = vKw > 0 ? 'text-success' : 'text-danger';
                                    fveSpan.innerHTML = `<strong class="${cls}">${formatted} kW</strong>`;
                                }
                            }
                        }
                        // Přidání/aktualizace čáry u FVE (používáme W hodnotu pro logiku toku)
                        this.updateLineForCell(fveCell, lightning.measuredFlowFveKw, counter, 'fve');
                    }

                    const battCell = objectWrapper.querySelector('.img-wrapper-left .img-wrapper-cell:nth-child(2)');
                    if (battCell) {
                        const battSpan = battCell.querySelector('span');
                        // Kladná = nabíjení (zeleně), záporná = vybíjení (červeně)
                        const vKw = lightning.batteryChargeKw;
                        if (battSpan) {
                            if (vKw === null || vKw === undefined) {
                                battSpan.innerHTML = 'N/A';
                            } else {
                                const formatted = vKw.toFixed(2);
                                if (vKw === 0) {
                                    battSpan.innerHTML = `<strong>${formatted} kW</strong>`;
                                } else {
                                    const cls = vKw > 0 ? 'text-success' : 'text-danger';
                                    battSpan.innerHTML = `<strong class="${cls}">${formatted} kW</strong>`;
                                }
                            }
                        }
                        // Přidání/aktualizace čáry u baterie
                        this.updateLineForCell(battCell, lightning.measuredFlowBatteryKw, counter, 'battery');
                    }

                    const houseCell = objectWrapper.querySelector('.img-wrapper-right .img-wrapper-cell');
                    if (houseCell) {
                        const houseSpan = houseCell.querySelector('span');
                        const vKw = lightning.measuredFlowHouseKw;
                        if (houseSpan) {
                            if (vKw === null || vKw === undefined) {
                                houseSpan.innerHTML = 'N/A';
                            } else {
                                const formatted = vKw.toFixed(2);
                                if (vKw === 0) {
                                    houseSpan.innerHTML = `<strong>${formatted} kW</strong>`;
                                } else {
                                    const cls = vKw > 0 ? 'text-success' : 'text-danger';
                                    houseSpan.innerHTML = `<strong class="${cls}">${formatted} kW</strong>`;
                                }
                            }
                        }
                    }

                    // Aktualizace celého popisu (description)
                    const allDescriptions = document.querySelectorAll('.balance-grid .balance-col-1 .description');
                    const description = allDescriptions[index];
                    if (description) {
                        const formatValueKw = (valueKw) => {
                            if (valueKw === null || valueKw === undefined) {
                                return '<strong>N/A</strong>';
                            }
                            const formatted = valueKw.toFixed(2);
                            if (valueKw === 0) {
                                return `<strong>${formatted} kW</strong>`;
                            }
                            const cls = valueKw > 0 ? 'text-success' : 'text-danger';
                            return `<strong class="${cls}">${formatted} kW</strong>`;
                        };

                        let fveState = '';
                        if (lightning.measuredFlowFveKw !== null && lightning.measuredFlowFveKw !== undefined) {
                            fveState = lightning.measuredFlowFveKw === 0 ? '(čeká na slunce)' : '(vyrábí el. energii)';
                        }

                        // Stav baterie s podmínkou
                        let batteryState = '';
                        if (lightning.batteryChargeKw !== null && lightning.batteryChargeKw !== undefined) {
                            if (lightning.batteryChargeKw > 0) {
                                batteryState = '(nabíjí se)';
                            } else if (lightning.batteryChargeKw < 0) {
                                batteryState = '(dodává energii)';
                            } else {
                                batteryState = '(čeká na příkaz)';
                            }
                        }

                        // Kapacita baterie - nový formát
                        let capacityPercent = 'N/A';
                        let capacityTotal = '';
                        if (lightning.availableCapacity !== null && lightning.capacity !== null) {
                            capacityPercent = '<strong>' + lightning.availableCapacity + '%</strong>';
                            capacityTotal = 'z celkových <strong>' + lightning.capacity + ' kWh</strong>';
                        }

                        description.innerHTML = `
                                    <strong>${lightning.username}</strong>
                                    <table class="table table-sm table-bordered table-striped table-hover mt-2 mb-0" style="font-size: 0.95em;">
                                        <tbody>
                                            <tr>
                                                <td>FVE aktuální stav</td>
                                                <td class="text-end">${formatValueKw(lightning.measuredFlowFveKw)}</td>
                                                <td>${fveState.replace(/[()]/g, '')}</td>
                                            </tr>
                                            <tr>
                                                <td>FVE instalovaný výkon</td>
                                                <td class="text-end">${lightning.fveInstalledKwp !== null && lightning.fveInstalledKwp !== undefined ? `<strong>${Number(lightning.fveInstalledKwp).toFixed(2)} kWp</strong>` : '<strong>N/A</strong>'}</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>FVE rezervovaný výkon</td>
                                                <td class="text-end">${lightning.fveReservedPercent !== null && lightning.fveReservedPercent !== undefined ? `<strong>${lightning.fveReservedPercent}%</strong>` : '<strong>N/A</strong>'}${lightning.fveReservedKwp !== null && lightning.fveReservedKwp !== undefined ? ` | <strong>${Number(lightning.fveReservedKwp).toFixed(2)} kW</strong>` : ''}</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>FVE nastavený limit</td>
                                                <td class="text-end">${lightning.fveLimitKwp !== null && lightning.fveLimitKwp !== undefined ? `<strong>${Number(lightning.fveLimitKwp).toFixed(2)} kW</strong>` : '<strong>N/A</strong>'}</td>
                                                <td></td>
                                            </tr>
                                            <tr class="table-group-spacer"><td colspan="3"></td></tr>
                                        </tbody>
                                        <tbody class="border-top-thick">
                                            <tr>
                                                <td>Aktuální stav baterie</td>
                                                <td class="text-end">${formatValueKw(lightning.batteryChargeKw)}</td>
                                                <td>${batteryState.replace(/[()]/g, '')}</td>
                                            </tr>
                                            <tr>
                                                <td>Kapacita baterie</td>
                                                <td class="text-end">${capacityPercent}</td>
                                                <td>${capacityTotal}</td>
                                            </tr>
                                            <tr>
                                                <td>SOC baterie ongrid</td>
                                                <td class="text-end">${lightning.socOngrid !== null && lightning.socOngrid !== undefined ? `<strong>${lightning.socOngrid}%</strong>` : '<strong>N/A</strong>'}</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>SOC baterie offgrid</td>
                                                <td class="text-end">${lightning.socOffgrid !== null && lightning.socOffgrid !== undefined ? `<strong>${lightning.socOffgrid}%</strong>` : '<strong>N/A</strong>'}</td>
                                                <td></td>
                                            </tr>
                                            <tr class="table-group-spacer"><td colspan="3"></td></tr>
                                        </tbody>
                                        <tbody class="border-top-thick">
                                            <tr>
                                                <td>Vnitřní spotřeba objektu</td>
                                                <td class="text-end">${formatValueKw(lightning.measuredFlowHouseKw)}</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td><strong>Průtok na patě objektu</strong></td>
                                                <td class="text-end">${formatValueKw(lightning.measuredFlowKw)}</td>
                                                <td>${lightning.measuredFlowKw > 0 ? 'přetok do sítě' : lightning.measuredFlowKw < 0 ? 'odběr ze sítě' : ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                `;
                    }

                    // Aktualizace linky směrem od objektu k distribuci
                    this.updateHorizontalLine(objectWrapper, lightning.measuredFlowKw, lightning.measuredFlowKw, counter, true, true);
                }

                // === LIGHTING MODE (double structure) ===
                if (isLightingMode) {
                    // Aktualizace ikony baterie
                    if (lightning.measuredFlowKw !== null && lightning.availableCapacityIcon !== null) {
                        const batteryImg = objectWrapper.querySelector('.img-wrapper-double img:nth-child(2)');
                        if (batteryImg) {
                            batteryImg.src = `/dist/imgs/battery-small-${lightning.availableCapacityIcon}.png?v2`;
                        }
                    }

                    // Aktualizace textových informací
                    const infoText = objectWrapper.querySelector('span');
                    if (infoText) {
                        let capacityText = 'N/A';
                        if (lightning.measuredFlowKw !== null && lightning.availableCapacity !== null) {
                            capacityText = `${lightning.availableCapacity} % z ${lightning.capacity} kWh`;
                        }

                        const flowKw = lightning.measuredFlowKw;
                        let flowText = 'N/A';
                        let flowClass = '';
                        if (flowKw !== null && flowKw !== undefined) {
                            flowText = flowKw.toFixed(2) + ' kW';
                            if (flowKw !== 0) {
                                flowClass = flowKw > 0 ? 'text-success' : 'text-danger';
                            }
                        }

                        infoText.innerHTML = `
                                <strong>${lightning.username}</strong><br>
                                Dostupná kapacita: ${capacityText} <br>
                                Povolený výkon: ${lightning.maxOutput} kW <br>
                                Měřený průtok: <strong class="${flowClass}">${flowText}</strong>
                            `;
                    }

                    // Aktualizace horizontální linky (bez span s hodnotou)
                    this.updateHorizontalLine(objectWrapper, lightning.measuredFlowKw, lightning.measuredFlowKw, counter, false);
                }
            });
        }

        // Aktualizace lamp
        if (balanceData.lamps) {
            balanceData.lamps.forEach((lamp, index) => {
                const counter = index + 1;

                console.log(lamp);

                // Detekce obou možných struktur
                let lampWrapper = document.querySelector(`.balance-grid .balance-col-5 .icon-wrapper.icon-wrapper-output:nth-child(${counter})`);
                if (!lampWrapper) {
                    lampWrapper = document.querySelector(`.balance-grid .balance-col-5 .icon-wrapper.icon-wrapper-lamps:nth-child(${counter})`);
                }

                if (lampWrapper) {
                    // Aktualizace textových informací
                    const infoText = lampWrapper.querySelector('span');
                    if (infoText) {
                        const isOutputMode = lampWrapper.classList.contains('icon-wrapper-output');

                        if (isOutputMode) {
                            infoText.innerHTML = `
                                    <strong>${lamp.username}</strong><br>
                                    ${this.getPowerHtmlLighting(lamp.sumKw)}
                                `;
                        } else {
                            infoText.innerHTML = `
                                    <strong>VO ${lamp.username}</strong><br>
                                    ${this.getPowerHtmlLighting(lamp.sumKw)}
                                `;
                        }
                    }

                    // Aktualizace linek indikujících proud
                    this.updateLampLine(lampWrapper, lamp.sumKw, counter);
                }
            });
        }
    }

    updateHorizontalLine(objectWrapper, measuredFlowW, measuredFlowKw, counter, includeTextSpan, isBalanceMode = false) {
        // let lineWrapper = objectWrapper.querySelector('.line-wrapper-horizontal, .line-wrapper:not(.line-wrapper-vertical)');
        let isVertical = false;
        let lineWrapper;
        if(isBalanceMode){
            lineWrapper = objectWrapper.querySelector(`.line-wrapper-flow-kw`);
        }
        else{
            lineWrapper = objectWrapper.querySelector(`.line-wrapper-horizontal, .line-wrapper:not(.line-wrapper-vertical)`);
        }
        if(lineWrapper && lineWrapper.classList.contains('line-wrapper-vertical')) {
            isVertical = true;
        }

        if (measuredFlowW !== null) {
            if (!lineWrapper) {
                // Vytvoření nové linky
                lineWrapper = document.createElement('div');
                if(isBalanceMode){
                    lineWrapper.className = `line-wrapper line-wrapper-flow-kw line-wrapper-${counter}${includeTextSpan ? ' line-wrapper-horizontal' : ''}`;
                }
                else{
                    lineWrapper.className = `line-wrapper line-wrapper-horizontal line-wrapper-${counter}`;
                }

                const animatedLine = document.createElement('div');
                animatedLine.className = measuredFlowW !== 0
                    ? `animated-line line-${measuredFlowW > 0 ? 'green' : 'red'}`
                    : 'animated-line';

                if (measuredFlowW !== 0) {
                    const lineDot = document.createElement('div');
                    lineDot.className = `line-dot ${measuredFlowW < 0 ? 'line-dot-revert' : ''}`;
                    animatedLine.appendChild(lineDot);
                }

                lineWrapper.appendChild(animatedLine);

                // Text span pouze pro balance mode - zobrazujeme hodnotu v kW
                if (includeTextSpan && measuredFlowKw !== null && measuredFlowKw !== undefined) {
                    const textSpan = document.createElement('span');
                    const formatted = measuredFlowKw.toFixed(2);
                    const flowClass = measuredFlowKw !== 0
                        ? (measuredFlowKw > 0 ? 'text-success' : 'text-danger')
                        : '';
                    textSpan.innerHTML = `<strong class="${flowClass}">${formatted} kW</strong>`;
                    lineWrapper.appendChild(textSpan);
                }

                objectWrapper.appendChild(lineWrapper);
            } else {
                // Aktualizace existující linky
                const animatedLine = lineWrapper.querySelector('.animated-line');
                if (animatedLine) {
                    animatedLine.className = measuredFlowW !== 0
                        ? `animated-line line-${measuredFlowW > 0 ? 'green' : 'red'}`
                        : 'animated-line';

                    let lineDot = animatedLine.querySelector('.line-dot');

                    if (measuredFlowW !== 0) {
                        if (!lineDot) {
                            lineDot = document.createElement('div');
                            animatedLine.appendChild(lineDot);
                        }
                        lineDot.className = `line-dot ${measuredFlowW < 0 ? 'line-dot-revert' : ''}`;
                    } else {
                        if (lineDot) {
                            lineDot.remove();
                        }
                    }
                }

                // Aktualizace text span (pouze pro balance mode) - zobrazujeme hodnotu v kW
                if (includeTextSpan && measuredFlowKw !== null && measuredFlowKw !== undefined) {
                    const innerSpan = lineWrapper.querySelector('span > strong');
                    const formatted = measuredFlowKw.toFixed(2);
                    const flowClass = measuredFlowKw !== 0
                        ? (measuredFlowKw > 0 ? 'text-success' : 'text-danger')
                        : '';
                    if (innerSpan) {
                        innerSpan.className = flowClass;
                        innerSpan.textContent = `${formatted} kW`;
                    } else {
                        const textSpan = document.createElement('span');
                        textSpan.innerHTML = `<strong class="${flowClass}">${formatted} kW</strong>`;
                        lineWrapper.appendChild(textSpan);
                    }
                }
            }
        } else if (lineWrapper) {
            // lineWrapper.remove();
        }
    }

    updateLampLine(lampWrapper, sum, counter) {
        let lineWrapper = lampWrapper.querySelector('.line-wrapper');

        if (sum !== null) {
            const hasFlow = sum !== 0;
            const isPositive = sum > 0;
            const lineColor = isPositive ? 'line-green' : 'line-red';

            if (!lineWrapper) {
                // Vytvořit linku, pokud sum !== null (i pro hodnotu 0)
                const newLineWrapper = document.createElement('div');
                newLineWrapper.className = `line-wrapper line-wrapper-${counter}`;

                const animatedLine = document.createElement('div');
                animatedLine.className = hasFlow ? `animated-line ${lineColor} line-mar-top` : 'animated-line line-mar-top';

                if (hasFlow) {
                    const lineDot = document.createElement('div');
                    lineDot.className = `line-dot${isPositive ? ' line-dot-revert' : ''}`;
                    animatedLine.appendChild(lineDot);
                }

                newLineWrapper.appendChild(animatedLine);
                lampWrapper.appendChild(newLineWrapper);
            } else {
                // Aktualizace existující linky
                const animatedLine = lineWrapper.querySelector('.animated-line');
                if (animatedLine) {
                    animatedLine.className = hasFlow ? `animated-line ${lineColor} line-mar-top` : 'animated-line line-mar-top';

                    let lineDot = animatedLine.querySelector('.line-dot');
                    if (hasFlow) {
                        if (!lineDot) {
                            lineDot = document.createElement('div');
                            animatedLine.appendChild(lineDot);
                        }
                        lineDot.className = `line-dot${isPositive ? ' line-dot-revert' : ''}`;
                    } else {
                        // Odstranit tečku, pokud není tok (sum === 0)
                        if (lineDot) {
                            lineDot.remove();
                        }
                    }
                }
            }
        } else if (lineWrapper) {
            lineWrapper.remove();
        }
    }

    updateLineForCell(cell, value, counter, type) {
        let lineWrapper = cell.querySelector('.line-wrapper-vertical');

        // U baterie je fyzikální znaménko opačné než uživatelské (záporná hodnota = nabíjení).
        // Barvu čáry proto určujeme z otočené hodnoty (nabíjení zeleně, vybíjení červeně),
        // směr tečky ale zůstává podle skutečného toku energie.
        const colorValue = type === 'battery' ? -value : value;

        if (value !== null) {
            if (!lineWrapper) {
                lineWrapper = document.createElement('div');
                lineWrapper.className = `line-wrapper line-wrapper-vertical line-wrapper-${counter}`;

                const animatedLine = document.createElement('div');
                animatedLine.className = value !== 0
                    ? `animated-line line-${colorValue > 0 ? 'green' : 'red'}`
                    : 'animated-line';

                if (value !== 0) {
                    const lineDot = document.createElement('div');
                    lineDot.className = `line-dot ${value < 0 ? 'line-dot-revert' : ''}`;
                    animatedLine.appendChild(lineDot);
                }

                lineWrapper.appendChild(animatedLine);
                cell.appendChild(lineWrapper);
            } else {
                const animatedLine = lineWrapper.querySelector('.animated-line');
                if (animatedLine) {
                    animatedLine.className = value !== 0
                        ? `animated-line line-${colorValue > 0 ? 'green' : 'red'}`
                        : 'animated-line';

                    let lineDot = animatedLine.querySelector('.line-dot');

                    if (value !== 0) {
                        if (!lineDot) {
                            lineDot = document.createElement('div');
                            animatedLine.appendChild(lineDot);
                        }
                        lineDot.className = `line-dot ${value < 0 ? 'line-dot-revert' : ''}`;
                    } else {
                        if (lineDot) {
                            lineDot.remove();
                        }
                    }
                }
            }
        } else if (lineWrapper) {
            // lineWrapper.remove();
        }
    }

    getPowerHtmlLighting(kwValue, bold = true) {
        if (kwValue === null || kwValue === undefined) {
            if (bold) {
                return "<strong>N/A</strong>";
            }
            return 'N/A';
        }

        const formatted = kwValue.toFixed(2);
        let html = formatted + ' kW';
        if (bold) {
            html = "<strong>" + html + "</strong>";
        }

        if (kwValue === 0) {
            html = "<span>" + html + "</span>";
        } else if (kwValue > 0) {
            html = "<span class='text-success'>" + html + "</span>";
        } else {
            html = "<span class='text-danger'>" + html + "</span>";
        }

        return html;
    }

    async postData(url, data) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error(`HTTP chyba! status: ${response.status}`);
            }

            return response.json();
        } catch (error) {
            console.error('Chyba při odesílání POST požadavku:', error);
            throw error;
        }
    }
}
